import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import logo from '../assets/logo.png';
import { useHistory } from 'react-router-dom';
import TarjetaResultado from '../components/TarjetaResultado';

const Resultados: React.FC = () => {
    const storeState: any = useSelector(state => state);
    const resultados = storeState.resultados;
    const history = useHistory();

    useEffect(() => {
        if (!resultados) {
            history.push('/');
        }
    }, [])

    return <>
        {
            resultados ?
                <div className='p-grid' style={{ color: '#525252' }}>
                    <div className='p-grid p-col-12'>
                        <div className='p-col-3 p-md-2 p-lg-2'>
                            <a href="/">
                                <img src={logo} alt="logo" className='Resultados-Logo' />
                            </a>
                        </div>
                        <div className='p-col-9 p-md-10 p-lg-10'>
                            <h2>Resultados de consulta</h2>
                            Término Consultado: <span style={{ fontWeight: 'bold', marginRight: 25 }}>{resultados.terminoConsulta} </span>
                            Registros encontrados: <span style={{ fontWeight: 'bold' }}>{resultados.totalDocumentos}</span>
                        </div>
                        <div className='p-col-3 p-md-2 p-lg-2' />
                        <div className='p-col-9 p-md-10 p-lg-10'>
                            {
                                resultados.result.map((registro: any) => (
                                    <TarjetaResultado key={registro._id}
                                        registro={registro}
                                        termino={resultados.terminoConsulta} />
                                ))
                            }
                        </div>
                    </div>
                </div>
                : <div />
        }
    </>
}

export default Resultados;